import HomePage from '../pages/Homepage';
import LandingPage from '../pages/LandingPage';

const Routes = [
    // { path: "/", element: <HomePage/> },
    { path: "/", element: <LandingPage/> },
    { path: "*", element: <h1>404 Not Found</h1> }
]

export default Routes;